module.exports = __webpack_public_path__ + "github.png?4b6250686618cac4d540ef0b2df6d9ca";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/github.png
// module id = 294
// module chunks = 0